import React from 'react';
import { Card, CardBody } from "reactstrap";
import avtarImage1 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function ChartListView({ delete_dashboard , handleViewDashboard }) {
    const {dashboard_list} = useSelector((state)=>state.Dashboard)
    const navigate = useNavigate()
 
  return (
    <React.Fragment>
        <Card>
            <CardBody className="no_padding">
                <div className="listjs-table" id="customerList">
                    <div className="table-responsive">
                        <table
                            className="table align-middle table-nowrap  no_margin"
                            id="customerTable"
                            >
                            <thead className="table-light">
                                <tr>
                                <th>Action</th>
                                <th>Dashboard Title</th>
                                <th                                   
                                    data-sort="type"
                                >
                                    Description
                                </th>
                                
                                <th                                   
                                    data-sort="group"
                                >
                                    Group
                                </th>                               
                                
                                
                                <th                                    
                                    data-sort="category"
                                >
                                    Category
                                </th>
                                <th className="" data-sort="last_use">
                                    Last Use
                                </th>
                                </tr>
                            </thead>
                            <tbody className="list form-check-all">
                                
                                
                               
                                    {dashboard_list?.data?.map((element,index)=>{
                                        // console.log(index);
                                        
                                        return <tr key={index} >
                                        <td>
                                            <i onClick={()=>{
                                               handleViewDashboard({Dashboard_Id:element.Dashboard_Id})
                                            }} className="mdi mdi-eye-circle-outline"/>
                                            <span onClick={()=>{
                                                delete_dashboard({dashboard_id:element.Dashboard_Id})
                                            }} ><i className="ri-delete-bin-line"/></span>                                       
                                        </td>
                                        <td>                                        
                                            <div className="d-flex gap-2 align-items-center">
                                            <div className="flex-shrink-0">
                                                <img
                                                    src={element.Dashboard_Logo}
                                                    alt=""
                                                    className="avatar-xs rounded-circle"
                                                />
                                            </div>
                                            <div className="flex-grow-1">{element.Dashboard_Title}</div>
                                            </div>
                                        </td>
                                        <td className="description">{element.Dashboard_Description}</td>
                                        <td className="Group">{element.Group_Name}</td>
                                        <td className="category">{element.Dashboard_Category}</td>
                                        <td className="last_use">
                                        {moment(element.Updated_At).format('YYYY-MM-DD')}

                                        </td>
                                        </tr>
                                    })}
                               
                            </tbody>
                            </table>
                    </div>
                </div>
            </CardBody>
        </Card>
    </React.Fragment>
  )
}

export default ChartListView